export default __webpack_public_path__ + "static/media/48.e43d4682.png";